import React from 'react';
import { Box, Typography } from '@mui/material';
import { GT_COLORS } from './constants';

interface TagPillsProps {
    tags: string[];
    onRemove?: (tag: string) => void;
    max?: number;
}

export const TagPills: React.FC<TagPillsProps> = ({ tags, onRemove, max }) => {
    const visible = max ? tags.slice(0, max) : tags;
    const overflow = max && tags.length > max ? tags.length - max : 0;

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
            {visible.map((tag) => (
                <Box
                    key={tag}
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontWeight: 500,
                        backgroundColor: GT_COLORS.badgeTagBg,
                        color: GT_COLORS.badgeTagColor,
                    }}
                >
                    {tag}
                    {onRemove && (
                        <Typography
                            component="span"
                            onClick={(e) => {
                                e.stopPropagation();
                                onRemove(tag);
                            }}
                            sx={{
                                cursor: 'pointer',
                                fontSize: '14px',
                                lineHeight: 1,
                                opacity: 0.6,
                                '&:hover': { opacity: 1 },
                            }}
                        >
                            &times;
                        </Typography>
                    )}
                </Box>
            ))}
            {overflow > 0 && (
                <Typography
                    sx={{
                        fontSize: '12px',
                        color: GT_COLORS.textFaint,
                        fontWeight: 500,
                    }}
                >
                    +{overflow}
                </Typography>
            )}
        </Box>
    );
};
